var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFurnitureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x36_",
    d: "M61.3,99.1V63.8c0-4.5,3.6-8.1,8.1-8.1h24.4c4.5,0,8.1,3.6,8.1,8.1v35.3H61.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x35_",
    x: 61.3,
    y: 117.2,
    width: 40.7,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_x34_",
    x: 61.3,
    y: 101.3,
    width: 40.7,
    height: 13.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x33_",
    d: "M50,83.2c-5,0-9,4.1-9,9s4.1,9,9,9v18.1c0,2.5,2,4.5,4.5,4.5v3.4H59v-3.4v-3.4V92.3C59,87.3,54.9,83.2,50,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x32_",
    d: "M113.3,83.2c-5,0-9,4.1-9,9v28.3v3.4v3.4h4.5v-3.4c2.5,0,4.5-2,4.5-4.5v-18.1c5,0,9-4.1,9-9 S118.3,83.2,113.3,83.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x31__1_",
    points: "35.3,118.3 35.3,36.9 59,36.9 54.5,0.7 9.3,0.7 4.7,36.9 28.5,36.9 28.5,118.3 25.1,118.3 22.8,127.3 40.9,127.3 38.7,118.3 "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnitureIcon);
export default __webpack_public_path__ + "static/media/furnitureIcon.0fdec63efe479a54fe7f4112f6f5571b.svg";
export { ForwardRef as ReactComponent };